export default __webpack_public_path__ + "static/media/25120416.f2188e20.jpg";